export const en = {
    translation: {
        common: {
            account: 'Account',
            loading: 'Loading...',
            cancel: 'Cancel',
            close: 'Close',
            verifyCode: 'Verify code',
            disable: 'Disable',
            setup: 'Set up',
            retry: 'Retry',
        },
        shell: {
            pageTitle: '{{tenantName}} Account',
            security: 'Security',
            securityDescription: 'Manage your password and secure your account with two-factor authentication.',
            securityNav: 'Security',
            signOut: 'Sign out',
            tenantSpace: 'Tenant account',
        },
        states: {
            missingTenantTitle: 'Missing tenant path',
            missingTenantDescription: 'This account app expects a URL in the shape of /t/:tenantSlug.',
            disabledTitle: 'Account management is disabled',
            disabledDescription: 'This tenant has not enabled the self-service account experience yet.',
            redirectingDescription: 'Redirecting to sign in...',
            redirectingBody: 'You need an active session to manage this account.',
            externalCredentialsTitle: 'Managed by your sign-in provider',
            externalCredentialsDescription:
                'Your sign-in settings are managed by the provider you use to access this account.',
            externalCredentialsBody:
                'Your password and sign-in verification methods are controlled by the provider you use to access this account.',
            notFoundTitle: 'Page Not Found',
            notFoundDescription: 'The page you are looking for does not exist.',
            fatalErrorTitle: 'Service Unavailable',
        },
        password: {
            description: 'Manage the password you use to sign in to this account.',
            unavailable: 'This identity does not currently use a local password for sign-in in this tenant.',
            itemTitle: 'Password',
            dialogTitle: 'Change password',
            dialogDescription: 'Choose a new password for future sign-ins.',
            changeAction: 'Change password',
            requirementsTitle: 'Requirements',
            newPassword: 'New Password',
            confirmPassword: 'Confirm New Password',
            confirmPasswordMismatch: 'Passwords do not match yet.',
            update: 'Update Password',
            requirements: {
                length: 'At least {{minLength}} characters',
                lower: 'One lowercase letter',
                upper: 'One uppercase letter',
                digit: 'One digit',
                special: 'One special character (e.g. - + _ ! @ # $ % ^ & * . , ? < > =)',
                noRepeat: 'No more than 2 identical characters in a row',
            },
        },
        mfa: {
            title: 'Two-Factor Authentication (2FA)',
            description: 'Add an extra layer of security to your account.',
            unavailable: 'Two-factor authentication is not available for this tenant.',
            on: 'On',
            off: 'Off',
            totpTitle: 'Authenticator App',
            totpDescription: 'Generate verification codes with an app like Google Authenticator, Authy, or 1Password.',
            emailTitle: 'Email Codes',
            emailDescription: 'Receive verification codes by email when you sign in.',
            removeTotp: 'Disable',
            setupTotp: 'Set up',
            enableEmail: 'Set up',
            resendEmail: 'Send new code',
            disableEmail: 'Disable',
            emailPendingTitle: 'Finish email verification',
            emailPendingDescription: 'Enter the verification code we sent to your primary email address.',
            emailCodeLabel: 'Verification code',
            totpModalTitle: 'Set up Authenticator',
            totpModalDescription:
                'Scan this QR code with your authenticator app. If scanning is not possible, you can enter the setup key manually.',
            totpCopy: 'Copy',
            totpCopied: 'Copied',
            totpCodeLabel: 'Enter the 6-digit code',
            totpVerify: 'Verify Code',
        },
        messages: {
            loadError: 'Unable to load the account experience.',
            signOutSuccess: 'You have been signed out of the account app.',
            signOutError: 'Unable to sign out right now.',
            passwordMismatch: 'The new password confirmation does not match.',
            passwordUpdated: 'Your password has been updated.',
            passwordUpdateError: 'Unable to change the password.',
            emailVerified: 'Email MFA has been enabled.',
            emailDisabled: 'Email MFA has been disabled.',
            emailUpdateError: 'Unable to update email MFA.',
            emailVerifyError: 'Unable to verify the email code.',
            totpEnabled: 'Authenticator app MFA has been enabled.',
            totpRemoved: 'Authenticator app MFA has been removed.',
            totpStartError: 'Unable to start authenticator setup.',
            totpVerifyError: 'Unable to verify the authenticator code.',
            totpRemoveError: 'Unable to remove the authenticator factor.',
        },
    },
}
